import {get} from './httpApi';

/*注册短信发送*/
export function sendByRegister(phone){
    return get('/sms/noJwt/sendByRegister',{
        phone
    })
}
/*验证码登录发送短信*/
export function sendByCodeLogin(phone){
    return get('/sms/noJwt/sendByCodeLogin',{
        phone
    })
}
/*找回密码短信发送*/
export function sendByFind(phone){
    return get('/sms/noJwt/sendByFind',{
        phone
    })
}
/*支付密码短信发送*/
export function sendByPay(phone){
    return get('/sms/noJwt/sendByFindForPay',{
        phone
    })
}